<template>
  <v-dialog v-if="user" :value="!user.accepted_terms" fullscreen persistent>
    <v-card class="d-flex flex-column">
      <v-card-title>
        Aceite os termos para continuar
        <v-spacer></v-spacer>
        <v-btn class="mr-3" text @click="notAccept()">Não aceitar</v-btn>
        <v-btn color="secondary" depressed :loading="loading" @click="accept()">Aceitar e continuar</v-btn>
      </v-card-title>
      <v-divider></v-divider>
      <div class="flex-grow-1 d-flex flex-column">
        <iframe class="flex-grow-1" src="https://www.zaper.in/gerenciador-de-links-termos-de-uso" height="100%" width="100%" sandbox="allow-scripts" frameborder="0"></iframe>
      </div>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapState } from 'vuex'

export default {
  data () {
    return {
      loading: false,
      ready: false
    }
  },
  computed: {
    ...mapState({
      user: state => state.auth.user
    })
  },
  methods: {
    notAccept () {
      this.$store.commit('links/SET_PREVIEW', null)
      this.$store.dispatch('auth/logout')
      this.$router.push('/auth')
    },
    async accept () {
      this.loading = true
      await this.$store.dispatch('auth/acceptTerms')
      this.loading = false

      this.$store.dispatch('links/storePreview')

      window.dataLayer.push({
        event: 'Lead'
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.terms-of-use {
  text-align: justify;

  .block {
    display: block;
  }

  .topic {
    font-weight: bold;
    margin-top: 15px;
    display: block;
    font-size: 1.2;
  }
}
</style>